import { Group } from "@visx/group";
import { AreaClosed, type PositionScale } from "@visx/shape";
import type { DateScale } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/types";
import { InfraEventPassengerCount } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/types";
import {
  getDate,
  getValue,
} from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/utils";
import { FC } from "react";

interface ChartAreaProps {
  data: InfraEventPassengerCount[];
  dateScale: DateScale;
  valueScale: PositionScale;
  marginLeft?: number;
}

export const ChartArea: FC<ChartAreaProps> = ({
  data: chartData,
  dateScale,
  valueScale,
  marginLeft,
}) => {
  const toEffectiveY = (d: InfraEventPassengerCount): number => {
    const passengers = getValue(d);
    const positivePassengerCount = Math.max(0, passengers);
    return valueScale(positivePassengerCount) ?? 0;
  };
  return (
    <Group left={marginLeft}>
      {/* Area for passengers */}
      <AreaClosed
        data={chartData}
        x={(d) => dateScale(getDate(d))}
        y={toEffectiveY}
        yScale={valueScale}
        strokeWidth={0}
        fill="url(#areaGradient)"
        opacity={0.8}
      />
      {/* Disbled for now */}
      {/* Area for ruter relief */}
      {/* <AreaClosed
        data={chartData}
        x={(d) => dateScale(getDate(d))}
        y={toEffectiveY}
        y0={(d) => valueScale(getValue(d))}
        yScale={valueScale}
        strokeWidth={0}
        fill={theme.colorOutlineSecondary}
        opacity={0.6}
        curve={curveMonotoneX}
      /> */}
    </Group>
  );
};
